export const splitLastWord = (text: string): { leading: string; lastWord: string } => {
  const trimmed = text.trim();
  const separatorIndex = trimmed.lastIndexOf(' ');

  if (separatorIndex === -1) {
    return { leading: '', lastWord: trimmed };
  }

  return {
    leading: trimmed.slice(0, separatorIndex).trimEnd(),
    lastWord: trimmed.slice(separatorIndex + 1),
  };
};
